import { ArenaRealtimeService } from './ArenaRealtimeService';

export const arenaRealtimeService = new ArenaRealtimeService();
export { ArenaRealtimeService };
